import React from 'react';
import './logicPro.css';
import Image from '../../../Components/Image';
import AB_LOGO from '../../../Assets/v2/header/logo.png';
import ABEDU_LOGO from '../../../Assets/v2/iit/abedu-logo.png';
import LOGICPRO_LOGO from '../../../Assets/v2/internships/logicpro-logo.png';
import IITDBannerImg from '../../../Assets/v2/iit/iitdbanner.png';
import Container from '../../../Components/Container';
import RequestCallbackForm from './RequestCallbackForm';
const Banner = () => {
  return (
    <section className="logicpro_section">
      <Container>
        <div className="logicpro_banner_container">
          <div className="logicpro_banner_left">
            <div className="logicpro_logoContainer">
              <div className="logicpro_abLogo">
                <Image
                  src={ABEDU_LOGO}
                  alt="AB logo"
                  className="internship_image"
                />
              </div>
              <span
                style={{ margin: '0px 15px' }}
                className="logicpro_uppercase">
                X
              </span>
              <div className="logicProLogo">
                <Image
                  src={LOGICPRO_LOGO}
                  alt="LogicPro Lucknow logo"
                  className="internship_image"
                />
              </div>
            </div>
            <h1 className="logicpro_collab_details">
              <span className="logicpro_uppercase">
                Alien Brains Educations
              </span>
              <span className="logicpro_collaborateText">
                Collaborates with
              </span>
              <span className="logicpro_uppercase">
                LogicPro Infosystems, Lucknow
              </span>
            </h1>
            <p className="logicpro_banner_text">
              <span className="logicpro_bold">
                Classes mode : Offline at LogicPro Office
              </span>
            </p>
            <p className="logicpro_banner_text">
              LogicPro Infosystems is coming up with one month Summer Training
              Program.
            </p>
            <p className="logicpro_banner_text">
              <span className="logicpro_bold">
                Certificate-based mentorship program via live projects
              </span>
            </p>
          </div>
          <div className="logicpro_banner_right">
            <RequestCallbackForm />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Banner;



// WEBPACK FOOTER //
// ./src/Pages/SummerInternships/LogicPro/Banner.js